<template>
  <div class="home">
    <div class="top-section">
      <welcome></welcome>

      <search-bar
        :full="false"
        v-on:show-modal="
          showModal = true;
          showTextSearch = false;
        "
        v-on:show-textsearch="
          showTextSearch = true;
          showModal = true;
        "
      ></search-bar>
    </div>

    <stats-container
      v-if="$store.getters.recommendedVideos.length > 0"
    ></stats-container>

    <!-- <div class="container top-items" id="recommended">
      <div class="columns">
        <top-video
          :item="$store.getters.recommendedVideos[0]"
          v-if="$store.getters.recommendedVideos.length > 0"
        ></top-video>
        <top-series :item="topSeries" v-if="topSeries"></top-series>
      </div>
    </div>

    <hr /> -->

    <h2 class="section-header">שיעורים חדשים</h2>

    <videos :videos="newVideos.slice(0, 4)"></videos>
    <div class="columns">
      <div class="column has-text-centered">
        <router-link
          class="yoga-btn-purple"
          :to="{ name: 'videolist', params: { sort: 'new' } }"
        >
          לכל השיעורים החדשים
        </router-link>
      </div>
    </div>
    <hr />

    <div v-if="topStyles.length > 0">
      <h2 class="section-header">{{ styleTitle(topStyles[0].label) }}</h2>
      <videos
        :videos="styleVideos(topStyles[0].resource.id).slice(0, 4)"
      ></videos>
    </div>
    <hr />

    <div v-if="topStyles.length > 1">
      <h2 class="section-header">{{ styleTitle(topStyles[1].label) }}</h2>
      <videos
        :videos="styleVideos(topStyles[1].resource.id).slice(0, 4)"
      ></videos>
    </div>

    <hr />

    <div v-if="topStyles.length === 0">
      <h2 class="section-header">שיעורים פופולריים</h2>
      <videos :videos="popularVideos.slice(0, 4)"></videos>
      <hr />
    </div>

    <div class="columns">
      <div class="column">
        <h2 class="section-header" id="my-series">תוכניות אימונים בשבילך</h2>

        <group-videos
          :items="
            $store.state.series.filter(i => i.parent === `10`).slice(0, 2)
          "
        >
        </group-videos>
        <div class="columns">
          <div class="column has-text-centered">
            <router-link class="yoga-btn-purple" :to="{ name: 'series' }">
              לכל תוכניות האימונים
            </router-link>
          </div>
        </div>
        <hr />
      </div>
    </div>

    <h2 class="section-header">כל המורים שאהבת</h2>
    <teachers :teachers="$store.state.user.myTeachers"></teachers>
    <div class="column has-text-centered">
      <router-link :to="{ name: 'teachers' }" class="yoga-btn-purple">
        לכל המורים
      </router-link>
    </div>

    <transition name="fade">
      <div :class="modalCls" v-if="showModal">
        <div class="modal-background" @click="showModal = false"></div>
        <div class="modal-wrapper">
          <div class="modal-content">
            <div v-if="showTextSearch" class="search-bar edit-results">
              <div class="columns" style="justify-content: space-between">
                <h3>אשמח למצוא שיעור</h3>
                <div class="has-text-left top-controls">
                  <a
                    href="#"
                    class="advanced-search-control"
                    @click.prevent="showTextSearch = false"
                    ><i class="mdi mdi-plus"></i> חיפוש מתקדם</a
                  >
                  <a
                    href="#"
                    class="advanced-search-control"
                    @click.prevent="showModal = false"
                    ><i class="mdi mdi-close"></i> חיפוש חופשי</a
                  >
                </div>
              </div>
              <div class="columns text-search-container">
                <div class="column is-9-desktop advanced-search-input">
                  <input
                    type="text"
                    class="input"
                    v-model="searchTerm"
                    placeholder="כאן ניתן לחפש חופשי..."
                    @keydown.enter="getResults"
                  />
                  <i class="mdi mdi-magnify"></i>
                </div>
                <div class="column is-3-desktop">
                  <a href="#" class="yoga-btn" @click.prevent="getResults"
                    >חיפוש</a
                  >
                </div>
              </div>
            </div>
            <advanced-search
              v-else
              v-on:close-edit-results="
                showModal = false;
                showTextSearch = false;
              "
              v-on:show-textsearch="showTextSearch = true"
            ></advanced-search>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import Welcome from "@/components/Welcome.vue";
import SearchBar from "@/components/SearchBar.vue";
import Videos from "@/components/Videos.vue";
import GroupVideos from "@/components/series/GroupVideos.vue";
import Teachers from "@/components/teachers/Teachers.vue";
import AdvancedSearch from "@/components/advancedSearch.vue";
import StatsContainer from "@/components/home/statsContainer.vue";

export default {
  name: `home`,
  components: {
    Welcome,
    SearchBar,
    Videos,
    GroupVideos,
    Teachers,
    AdvancedSearch,
    StatsContainer,
  },
  data() {
    return {
      groupItems: [],
      showModal: false,
      showTextSearch: false,
      searchTerm: "",
    };
  },
  computed: {
    videoList() {
      return this.$store.state.videos;
    },
    myvideos() {
      const vidArray = this.$store.state.user.myVideos;
      if (vidArray.length !== 0) {
        const arr = this.videoList.filter(v => {
          if (vidArray.includes(v.id)) {
            return true;
          }
          return false;
        });
        return arr.slice(0, 4);
      }
      return [];
    },
    newVideos() {
      if (Array.isArray(this.$store.getters.newVideos)) {
        const v = [];
        const t = [];

        this.$store.getters.newVideos.forEach(video => {
          if (t.indexOf(video.videoTeacher) === -1) {
            v.push(video);
            t.push(video.videoTeacher);
          }
        });
        return v;
      }
      return [];
    },

    popularVideos() {
      const filtered = this.videoList.filter(v =>
        this.$store.state.initialData.popular.includes(`${v.id}`)
      );
      return filtered;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },

    topStyles() {
      return this.$store.getters.topStyles.map(item =>
        this.$store.getters.getStyle(item)
      );
    },
    modalCls() {
      if (this.showModal) {
        return "modal is-active";
      }
      return "modal";
    },

    // topSeries() {
    //   let output = [];
    //   const watched = this.$store.state.user.seriesHistory;
    //   watched.forEach(item => {
    //     const series = this.getSeries(item.id);
    //     if (
    //       series &&
    //       series.videoItems.split("||").length > item.watched.split(",").length
    //     ) {
    //       output.push(series);
    //     }
    //   });
    //   if (output.length > 0) {
    //     return this.shuffle(output)[0];
    //   }
    //   return false;
    // },
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch(`clearResults`);
    });
  },
  mounted() {
    this.$store.dispatch(`setSearchParams`, {
      metaStyles: [],
      styles: [],
      levels: [],
      durations: [],
      tempo: [],
      teachers: [],
      focus: [],
      bodyPart: [],
      equipment: [],
    });
  },
  methods: {
    getResults(e) {
      let obj = {
        term: this.searchTerm,
        metaStyles: this.flattenQuery(
          this.$store.state.sort.selected.metaStyles
        ),
        styles: this.falttenStylesQuery(this.$store.state.sort.selected.styles),
        levels: this.flattenQuery(this.$store.state.sort.selected.levels),
        durations: this.flattenQuery(this.$store.state.sort.selected.durations),
        tempo: this.flattenQuery(this.$store.state.sort.selected.tempo),
        teachers: this.flattenQuery(this.$store.state.sort.selected.teachers),
        focus: this.flattenQuery(this.$store.state.sort.selected.focus),
        bodyPart: this.flattenQuery(this.$store.state.sort.selected.bodyPart),
        equipment: this.flattenQuery(this.$store.state.sort.selected.equipment),
      };

      this.$store.dispatch(`getVideoResults`, obj);
      this.$store.commit("setSearchTerm", this.searchTerm);
      e.currentTarget.blur();
      this.$router.push("results");
    },
    flattenQuery(arr) {
      if (arr) {
        const ids = arr.map(item => item.id);
        return ids.join(",");
      }
      return "";
    },
    falttenStylesQuery(arr) {
      if (arr) {
        const ids = arr.map(item => item.resource.id);
        return ids.join(",");
      }
      return arr;
    },
    styleTitle(title) {
      return "שיעורי " + title + " בשבילך";
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    styleVideos(style) {
      let videos = this.$store.state.videos.filter(
        video => video.current === style
      );
      return this.shuffle(videos);
    },
    getSeries(id) {
      if (this.$store.state.series.length > 0) {
        const arr = this.$store.state.series.filter(item => {
          if (item.id === id) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return {};
    },
  },
};
</script>

<style lang="scss">
.home {
  .modal {
    align-items: flex-start;
    padding-top: 10%;
  }

  .modal-content {
    min-width: 60%;
    max-width: 1200px;
    min-height: 0.5vh;
    background-color: #ffffff;
    padding: 2rem 0.5rem;
    box-shadow: 7px 4px 10px rgba(0, 0, 0, 0.25);
  }
  .modal-background {
    background-color: rgba(10, 10, 10, 0.6);
  }
}

.modal.is-active {
  z-index: 120;
}

.no-recs {
  background-color: aliceblue;
  text-align: center;
  h3 {
    font-weight: bold;
    font-size: 18px;
  }
  p {
    margin: 10px 0;
  }
}

.top-section {
  background-color: #f6f6f6;
  padding: 2rem 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 2rem;
}

.top-items {
  padding: 2rem 0 0;
}
</style>

